import { render } from "./SendPwdResetMailComponent.vue?vue&type=template&id=3c1546eb&scoped=true&ts=true"
import script from "./SendPwdResetMailComponent.vue?vue&type=script&lang=ts"
export * from "./SendPwdResetMailComponent.vue?vue&type=script&lang=ts"

import "./SendPwdResetMailComponent.vue?vue&type=style&index=0&id=3c1546eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1546eb"]])

export default __exports__